import { ReactNode } from 'react';
import { Dialpad, PhoneForwarded, RecordVoiceOver } from '@mui/icons-material';
import { CallsMenuStageType } from '@bandido/shared/constants';

export const getStageIcon = (type: CallsMenuStageType, isMain?: boolean): ReactNode => {
  if (type === CallsMenuStageType.SUB_MENU) {
    if (isMain) {
      return <RecordVoiceOver color="info" fontSize="small" />;
    }
    return <Dialpad color="primary" fontSize="small" />;
  }

  return <PhoneForwarded color="success" fontSize="small" />;
};

export const handleDragStart = (event: React.DragEvent<HTMLDivElement>, type: CallsMenuStageType): void => {
  event.dataTransfer.setData('application/reactflow', type);
  event.dataTransfer.effectAllowed = 'move';
};

export const onDragOver = (event: any) => {
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';
};
